module.exports = __webpack_public_path__ + "static/img/bg_pop_move@2x.cc4531e3.png";